import React, { FC } from 'react';
import { Box } from '@chakra-ui/react';

import { useApi, useFetchData } from '@app/hooks';
import { QueryTable } from '@app/components/common/table';
import { Transaction } from '@app/api/models/transaction';

import { useColumns } from './columns';

interface ViewProps {
  title: string;
  id: string;
}

const View: FC<ViewProps> = (props) => {
  const { title, id } = props;
  const api = useApi();

  const [fetchData] = useFetchData({
    method: (payload) =>  api.transaction.getTransactions({ 
      ...payload,  
      filter: { 
        ...payload.filter, 
        equip_id: id
      }
    }), 
  });


  const columns = useColumns();

  return (
    <Box mx={-6} mb={-6} mt={-2} minW={500}>
      <QueryTable<Transaction>
        title={title}
        columns={columns}
        fetchData={fetchData}
        ignoreQuery
      />
    </Box>
  );
};

export default View;
